import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import CreateRepository from '../Repositories/CreateRepository'


class CreateBloc {

    createChannel = new Subject();
    repository = new CreateRepository()
    employeeChannel = new Subject();
    educationChannel = new Subject();
    educationGroupChannel = new Subject();
  
    constructor() {
        this.createChannel.next({status: apiResponse.INITIAL})
        this.employeeChannel.next({status: apiResponse.INITIAL})
        this.educationChannel.next({status: apiResponse.INITIAL})
        this.educationGroupChannel.next({status: apiResponse.INITIAL})
    }

    fetchCreate = async (query) => {
        try {
            this.createChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchCreate(query).then((result) => {
                this.createChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.createChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {console.log("rxjs", "Channel unsubscribed")}
    }

    fetchEmployee = async (query) => {
        try {
            this.employeeChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchEmployee(query).then((result) => {
                this.employeeChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.employeeChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {console.log("rxjs", "Channel unsubscribed")}
    }

    fetchEducation = async (query) => {
        try {
            this.educationChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchEducation(query).then((result) => {
                this.educationChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.educationChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {console.log("rxjs", "Channel unsubscribed")}
    }

    fetchEducationGroup = async (query) => {
        try {
            this.educationGroupChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchEducationGroup(query).then((result) => {
                this.educationGroupChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.educationGroupChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {console.log("rxjs", "Channel unsubscribed")}
    }
    
}

export default CreateBloc